import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';

function AuthCallback() {
  const { t } = useTranslation();
  const [status, setStatus] = useState(t('auth.processing') || 'Processing...');
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();

  useEffect(() => {
    let processed = false;
    
    const processAuth = async () => {
      if (processed) return;
      processed = true;
      
      try {
        const success = await handleGoogleCallback();
        if (success) {
          setStatus(t('auth.successRedirecting') || 'Success! Redirecting...');
          setTimeout(() => navigate('/'), 1000);
        } else {
          setStatus(t('auth.googleAuthFailed') || 'Google authentication failed. Redirecting to login...');
          setTimeout(() => navigate('/login'), 2000);
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        setStatus(t('auth.googleAuthFailed') || 'Google authentication failed. Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    processAuth();
  }, []); // Empty deps - only run once on mount

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-blue-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-lg text-gray-700">{status}</p>
      </div>
    </div>
  );
}

export default AuthCallback;